// Order matterrs
import Vue from 'vue'
import store from 'Store'
import i18n from './i18n'
import router from './router'
import VueCookies from 'vue-cookies'
import Directives from 'Directives'
import Vuelidate from 'vuelidate'
import Sortable from 'Plugins/sortable/install'
import 'nprogress/nprogress.css'
import App from './App.vue'

Vue.use(Vuelidate)
Vue.prototype.$Sortable = Sortable
/**
 * Event Bus
 *
 * For events listenings between component
 * without the help of a parent component.
 */
export const EventBus = new Vue()

/**
 * Main Vue instance.
 */
Vue.config.productionTip = true

new Vue({
  store,
  router,
  i18n,
  VueCookies,
  Directives,
  created() {
    // If there's a user logged in, we automatically logged it back in on reload.
    const user = JSON.parse(localStorage.getItem('currentUser')) || VueCookies.get('currentUser')
    if (!user) return
    store.dispatch('user/loadUser', user)
  },
  render: (h) => h(App),
}).$mount('#app')
